var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    attrs: {
      "id": "event-form"
    },
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.saveEvent.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "podnikamOd"
    }
  }, [_vm._v("Termín podpisu")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.meetingDate,
      expression: "meetingDate"
    }],
    staticClass: "text-input w-input date-input",
    attrs: {
      "type": "datetime-local",
      "min": _vm.todayLong,
      "maxlength": "256",
      "name": "podnikamOd",
      "data-name": "podnikamOd",
      "id": "podnikamOd",
      "required": ""
    },
    domProps: {
      "value": _vm.meetingDate
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.meetingDate = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "pb-2"
  }, [_c('div', {
    staticClass: "dropdown-input-custom rest-input"
  }, [_c('dropdown-select', {
    attrs: {
      "id": 'podpis',
      "init-value": _vm.signLocal,
      "options": _vm.booleanForm,
      "name": 'Podpis u nás',
      "normal": ""
    },
    on: {
      "select": function select($event) {
        return _vm.setDropdownValue($event);
      }
    }
  })], 1)]), !_vm.signLocal ? _c('div', [_c('sidlo-input', {
    attrs: {
      "not-required": {
        orientacne: true
      },
      "not-included": {
        supisne: true
      },
      "type": 'house'
    },
    on: {
      "address-change": function addressChange($event) {
        return _vm.setAddress($event);
      }
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "input-group"
  }, [_c('label', {
    staticClass: "field-label",
    attrs: {
      "for": "sprava"
    }
  }, [_vm._v("Správa pre klienta")]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.invitationForm.description,
      expression: "invitationForm.description"
    }],
    staticClass: "text-input w-input",
    attrs: {
      "id": "sprava"
    },
    domProps: {
      "value": _vm.invitationForm.description
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.$set(_vm.invitationForm, "description", $event.target.value);
      }
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }